export default __webpack_public_path__ + "static/media/pin_spot.d1fff729.svg";